import { useTranslation } from 'react-i18next';
import { Reveal, RevealHeading, RevealGroup, RevealItem } from '../components/Reveal';

const AboutBreedPage = () => {
  const { t } = useTranslation();

  return (
    <div className="animate-fadeIn">
      <section className="my-12 md:my-20 text-center">
        <RevealHeading as="h1" text={t('aboutBreed.title')} className="text-4xl md:text-5xl text-brand-accent" />
        <Reveal as="p" delay={0.18} className="mt-4 text-lg md:text-xl text-brand-text-light/80 max-w-2xl mx-auto">
          {t('aboutBreed.subtitle')}
        </Reveal>
      </section>

      <div className="max-w-4xl mx-auto">
        <section className="my-12">
          <RevealHeading as="h2" text={t('aboutBreed.history.title')} className="text-3xl md:text-4xl mb-6 text-brand-accent" />
          <RevealGroup className="space-y-4 text-brand-text-light/80 leading-relaxed">
            <RevealItem as="p">{t('aboutBreed.history.p1')}</RevealItem>
          </RevealGroup>
        </section>

        <section className="my-12">
          <RevealHeading as="h2" text={t('aboutBreed.character.title')} className="text-3xl md:text-4xl mb-6 text-brand-accent" />
          <RevealGroup className="space-y-4 text-brand-text-light/80 leading-relaxed">
            <RevealItem as="p">{t('aboutBreed.character.p1')}</RevealItem>
            <RevealItem as="p">{t('aboutBreed.character.p2')}</RevealItem>
          </RevealGroup>
        </section>
      </div>
    </div>
  );
};

export default AboutBreedPage;
